import { initAppAnalytics } from "@hamdevco/analytics/app";
// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./pwa"
import { drainGtmEvents } from "./gtm_events"

// Fires server-queued GA4 key events (sign_up, generate_lead, start_trial,
// purchase, ...) after EVERY Turbo navigation, not just a fresh page parse --
// see gtm_events.js for why an inline <script> in <head> silently drops these
// on any Turbo-driven Visit (which is every navigation on this bundle).
document.addEventListener("turbo:load", drainGtmEvents)

import "trix"
import "@rails/actiontext"

// PostHog for the authenticated product. Ingest is proxied same-origin at
// /ingest by IngestController. The token is a literal: a phc_ project key is
// public by design and must reach the browser either way.
// Production only. The server renders `analytics-enabled` inside the same
// `Rails.env.production?` block that gates GA4/GTM (shared/_head.html.slim).
// Ungated, posthog-js also runs in dev and test — and since ingest is proxied
// same-origin, its calls leave IngestController as real outbound HTTP instead
// of plain browser requests. WebMock refuses those in test, raising inside the
// app and failing every system test on a page that only rendered.
const analyticsEnabled = !!document.querySelector('meta[name="analytics-enabled"]');

if (analyticsEnabled) {
  initAppAnalytics({
    token: "phc_r8BXeJzU4YtXWfC3xTEcm6DFXugJjK8VinQF2fQbBX43", // HamDevCo Web (590688)
    app: "stowlane",
    owner: "hamdevco",
    // Session replay ON: our own product, so replay showing where a user gets
    // stuck in the app is worth the recording. Inputs are masked; any PII
    // rendered as TEXT still needs data-ph-mask.
    replay: true,
  });
}
